import { render, staticRenderFns } from "./myLesson.vue?vue&type=template&id=22b6ce9b&scoped=true"
import script from "./myLesson.vue?vue&type=script&lang=js"
export * from "./myLesson.vue?vue&type=script&lang=js"
import style0 from "./myLesson.vue?vue&type=style&index=0&id=22b6ce9b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b6ce9b",
  null
  
)

export default component.exports